import { Injectable } from '@angular/core';
import { PubSubService, declareEvent } from './pubsub.service';

export enum FocusState {
  Off = 'off',
  On = 'on',
}

export const focusStateChangedEvent = declareEvent<FocusState>('focusStateChanged');

@Injectable({
  providedIn: 'root'
})
export class FocusStateService {

  private _focusState: FocusState = FocusState.On;

  constructor(private pubSubService: PubSubService) {
    window.addEventListener('focus', () => this.handleFocusChange(FocusState.On, 'focus'), { passive: true, capture: true });
    window.addEventListener('blur', () => this.handleFocusChange(FocusState.Off, 'focus'));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        this.handleFocusChange(FocusState.On, 'visibility');
      } else {
        this.handleFocusChange(FocusState.Off, 'visibility');
      }
    });
  }

  public get focusState(): FocusState {
    return this._focusState;
  }

  private set focusState(newState: FocusState) {
    if (this._focusState !== newState) {
      this._focusState = newState;
      this.pubSubService.publish(focusStateChangedEvent, newState);
    }
  }

  private handleFocusChange(state: FocusState, source: 'focus' | 'visibility') {
    if (this.focusState === state) {
      //console.log(`App: Focus state already ${state}, ignoring source ${source}.`);
      return; // no change, so ignore
    }
    // #5179: console.info, not console.log. LoggingService drops `log` in a
    // production build, and the native FreezeWatchdog boot log captures the real
    // console — so as a `log` line this was invisible in every store build, which
    // is exactly where boot-freeze-classifier.ts's wasBackgrounded() needs to
    // read it. Pinned by a source tripwire in boot-freeze-classifier.test.ts.
    console.info(`App: Focus ${state}, Source: ${source}`);
    this.focusState = state;
  }
}
